import Button from "@/components/Button";
export interface DepositFooterProps {
	text?: string;
	loading?: boolean;
	disabled?: boolean;
	extra?: React.ReactNode;
	bottomExtra?: React.ReactNode;
	hiddenBtn?: boolean;
	onClick?: () => void;
}

export default function DepositFooter({
	text,
	loading,
	disabled,
	extra,
	bottomExtra,
	onClick,
	hiddenBtn,
}: DepositFooterProps) {
	const handleClick = () => {
		if (loading || disabled) return;
		onClick && onClick();
	};

	return (
		<footer className="flex-shrink-0 px-4 py-6">
			{extra && extra}
			{!hiddenBtn && (
				<Button onClick={handleClick} loading={loading} disabled={disabled} block>
					{text}
				</Button>
			)}
			{bottomExtra && bottomExtra}
		</footer>
	);
}
